import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Select,
} from 'antd';
import { getReferredStatuses } from '../../../actions/userProfile';
import {
  normalizeToArray,
  isEmptySelection,
  stringifyWithArrays,
} from './utils/multiSelectUtils';

class ReferredSearchSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStatus: normalizeToArray(props.paramTools.params[props.queryType]),
      referredStatuses: [],
    };
  }

  componentDidMount = async () => {
    await this.props.getReferredStatuses();
    this.setState({ referredStatuses: this.props.allReferredStatuses });
  }

  updateQuery = async (referred) => {
    const normalized = normalizeToArray(referred);
    this.setState({ selectedStatus: normalized });
    const { paramTools, inboxActions, queryType } = this.props;
    const { params } = paramTools;
    const { getRecords } = inboxActions;
    if (isEmptySelection(normalized)) {
      delete params[queryType];
      params.page = 1;
    } else {
      params[queryType] = normalized;
      params.page = 1;
    }
    const query = stringifyWithArrays(params);
    await getRecords(query);
  }

  render() {
    const { referredStatuses, selectedStatus } = this.state;
    return (
      <div>
        <Select
          showSearch
          style={{ width: '220px', marginTop: 20 }}
          label="Referred Status"
          placeholder="Search by Status"
          allowClear
          value={selectedStatus}
          mode="multiple"
          onChange={option => this.updateQuery(option)}
        >
          {[...referredStatuses]
            .sort((a, b) => (b.active === true ? 1 : 0) - (a.active === true ? 1 : 0))
            .map(referredStatus => (
              <Select.Option
                key={referredStatus.id}
                value={referredStatus.name}
                style={referredStatus.active === false ? { color: '#999' } : {}}
              >
                {referredStatus.name}{referredStatus.active === false ? ' (Deactivated)' : ''}
              </Select.Option>
            ))}
        </Select>
      </div>
    );
  }
}

ReferredSearchSettings.propTypes = {
  inboxActions: PropTypes.object.isRequired,
  paramTools: PropTypes.object.isRequired,
  queryType: PropTypes.string,
  allReferredStatuses: PropTypes.object.isRequired,
  getReferredStatuses: PropTypes.func.isRequired,
};

ReferredSearchSettings.defaultProps = {
  queryType: 'referred',
};

export default connect(state => ({
  //referredStatuses: state.auth,
  allReferredStatuses: state.userProfile.allReferredStatuses,
}), {
  getReferredStatuses,
})(ReferredSearchSettings);
